exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.short {\n  display: inline-block;\n  max-width: 50px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/cards/cards-summary/cards-summary.component.scss
// module id = ../../../../../src/app/pages/dashboard/cards/cards-summary/cards-summary.component.scss
// module chunks = main